import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CollectionCatogoryListing, CollectionCatogoryAddEdit } from './Pages';

export const CollectionCategoryMaster = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={CollectionCatogoryListing} />
        <Route exact path={`${match.path}/AddEdit`} component={CollectionCatogoryAddEdit} />
    </Fragment>
)